import React, { useEffect, useState } from 'react';
import { axiosInstance } from '../../config';
import Sidebar from '../common/sidebar/Sidebar';
import { Link } from 'react-router-dom';
import AdminLoader from '../components/AdminLoader';
import {  AiFillDelete, AiFillEdit } from "react-icons/ai";




const FaqCategory = () => {
    const [category, setcategory] = useState()
    const [del, setdel] = useState(false)

    useEffect(() => {
        getfaqcategory()
    }, [!del])



    const getfaqcategory = async () => {
        try {
            const { data } = await axiosInstance.get("/api/faqcategory/");
            setcategory(data)
            
        } catch (error) {
            
        }
    }


    const togglehandle = (e) => {
        e.persist();
        var menu_btn = document.querySelector("#menu-btn");
        var sidebar = document.querySelector("#sidebar");
        var container = document.querySelector(".my-container");
        sidebar.classList.toggle("active-nav")
        container.classList.toggle("active-cont");
    }

    const deletecategory = async (id) => {
        var answer = window.confirm("Are you sure To delete?");
        if (answer) {
            await axiosInstance.delete(`/api/faqcategory/${id}`, {
                headers: {
                    'token': localStorage.getItem("token")
                },
            });

            alert("deleted");

            setTimeout(() => {
                setdel(!del);
            }, 100);
        }
    }
  return (
    <>
    <Sidebar />
      <div className="p-1 my-container active-cont overflow-hidden">
                {/* <!-- Top Nav --> */}
                <nav className="navbar top-navbar navbar-light bg-light px-5">
                    <a className="btn border-0" id="menu-btn" onClick={togglehandle}><i className="bx bx-menu"></i></a>
                </nav>
                {/* <!--End Top Nav --> */}
                <h3 className="text-dark p-3">ADMIN FAQ TYPES
                </h3>



                <div className="container p-3" style={{ boxShadow: ' rgba(0, 0, 0, 0.35) 0px 5px 15px' }}>
                    <div className="row text-start">
                        <div className=""><Link to="/admin/addfaqcategory" className="text-white btn btn-success rounded px-5">Add New FAQ Category</Link></div>
                    </div>
                    <div className="row mb-4 border-bottom text-start">
                        <div className="col-md-3 "><b> FAQ Category Name</b></div>

                        <div className="col-md-3 "><b>EXTRA OPTIONS</b></div>
                    </div>


                    {
                        !category ? <AdminLoader/>: category.length === 0 ? <>
                            <div className="row d-flex justify-content-center mt-5">
                                <div className="col-md-8 text-center">
                                    <h4>No category Available</h4>
                                </div>
                            </div>
                        </> :

                            category && category.map((category) => (
                                <>
                                    <div className="row text-start pb-2">
                                        <div className="col-md-3 ">{category?.faqQuestionType}</div>
                            
                                      
                                        <div className="col-md-3 p">
                                            <div className="row">
                                                {/* <div className="col-md-4">
                                                    <AiFillEye color='red' size={25} onClick={() => showdetails(category)} />
                                                </div> */}
                                                <div className="col-md-4" style={{cursor:"pointer"}}>
                                                    <AiFillDelete color='black' size={30} onClick={() =>
                                                        deletecategory(category._id)} />
                                                </div>
                                                <div className="col-md-4">
                                                    <Link className="col-md-1" to={`/admin/editfaqcategory/${category._id}`} ><AiFillEdit size={25} color="blue" />  </Link>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </>
                            ))
                    }
                </div>
            </div>
    
    </>
  )
}

export default FaqCategory